type LogLevel = 'debug' | 'info' | 'warn' | 'error' | 'silent';

const levelOrder: Record<LogLevel, number> = {
  debug: 10,
  info: 20,
  warn: 30,
  error: 40,
  silent: 100,
};

function getLevel(): LogLevel {
  try {
    const fromEnv = (
      process.env.REACT_APP_LOG_LEVEL ||
      process.env.LOG_LEVEL ||
      ''
    ).toLowerCase();
    const fromStorage =
      (typeof localStorage !== 'undefined' &&
        localStorage.getItem('logLevel')) ||
      '';
    const val = (fromEnv || fromStorage || '').toLowerCase() as LogLevel;
    if (val && levelOrder[val] !== undefined) return val;
  } catch {}
  // Default: production -> warn, development -> info
  const isProd = process.env.NODE_ENV === 'production';
  return isProd ? 'warn' : 'info';
}

let currentLevel: LogLevel = getLevel();

export const log = {
  setLevel(lvl: LogLevel) {
    currentLevel = lvl;
    try {
      localStorage.setItem('logLevel', lvl);
    } catch {}
  },
  debug: (...args: any[]) => {
    if (levelOrder[currentLevel] <= levelOrder.debug) console.debug(...args);
  },
  info: (...args: any[]) => {
    if (levelOrder[currentLevel] <= levelOrder.info) console.info(...args);
  },
  warn: (...args: any[]) => {
    if (levelOrder[currentLevel] <= levelOrder.warn) console.warn(...args);
  },
  error: (...args: any[]) => {
    if (levelOrder[currentLevel] <= levelOrder.error) console.error(...args);
  },
};

export default log;
